import React from "react";
import PdfViewer from "../../PdfViewer";

const PythonTema5 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/Tema5_Organizacion_Codigo.pdf`;
  /*const pdfUrl = "/pdf/Tema5_Organizacion_Codigo.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Tema 5: Organización de Código</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default PythonTema5;
